import React from 'react';
import { Box, Flex, Icon, Spacer, Text } from '@televet/kibble-ui';

export type TableColumnSortOrder = 'asc' | 'desc' | undefined;

interface TableColumnSortProps {
  label: string;
  sortOrder: TableColumnSortOrder;
  onSort: (sortOrder: TableColumnSortOrder) => void;
  useIndeterminateSort?: boolean;
}

export const TableColumnSort = ({
  label,
  sortOrder,
  onSort,
  useIndeterminateSort,
}: TableColumnSortProps): JSX.Element => {
  const handleIndeterminateSort = (): void => {
    const options: TableColumnSortOrder[] = [undefined, 'asc', 'desc'];
    const i = options.indexOf(sortOrder) + 1;
    sortOrder = options[i];
    onSort(options[i]);
  };

  const handleSort = (): void => {
    sortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    onSort(sortOrder);
  };

  return (
    <Flex>
      <Flex
        align="center"
        borderRadius="base"
        px={2}
        py={1}
        _hover={{ bgColor: 'background.alpha.hover' }}
        backgroundColor={!!sortOrder ? 'background.alpha.hover' : 'transparent'}
        cursor="pointer"
        onClick={useIndeterminateSort ? handleIndeterminateSort : handleSort}
      >
        <Text size="xs" as="div" mr={1} my="1px">
          {label}
        </Text>
        {sortOrder ? (
          <Box
            transform={sortOrder === 'asc' ? 'scale(1,-1)' : ''}
            transition={'transform 0.1s ease-in-out'}
            w="16px"
            display="flex"
          >
            <Icon name="arrowDown" size="sm" />
          </Box>
        ) : (
          <Box w="16px" display="flex">
            <Icon name="sort" size="sm" />
          </Box>
        )}
      </Flex>
      <Spacer />
    </Flex>
  );
};
